module.exports = __webpack_public_path__ + "static/3-f776f08f7cdf39809c65907127a7f782.jpg";